import { hbs } from 'ember-cli-htmlbars';
export default hbs("<div class=\"nw-subheader\">\n  <h2>{{yield}}</h2>\n</div>")